export default defineNuxtRouteMiddleware((to, from) => {
	if (to.path !== from.path && import.meta.client) {
		document.body.scrollTo({
			top: 0,
			left: 0,
			behavior: 'instant'
		});
	}
});
